import { Location } from "@angular/common";
import { Component, Input, OnInit, ElementRef, ViewChild, Output, EventEmitter, TemplateRef, ChangeDetectorRef, HostListener, SimpleChanges } from "@angular/core";
// Moment
import moment from "moment-timezone";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { NgxSpinnerService } from "ngx-spinner";
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Site } from "../../app/interfaces/sites";
import { Filter, User } from "../../app/interfaces/user";
import { LicenseService } from "../../app/services/license.service";
import { SiteService } from "../../app/services/site.service";
import { CurrencyService } from "../../app/services/currency.service";
import { UserService } from "../../app/services/user.service";
import { TranslateService } from '@ngx-translate/core';
import { IAngularMyDpOptions, IMyDateModel } from 'angular-mydatepicker';
import { KeyValue } from "@angular/common";
import { BsDropdownDirective } from "ngx-bootstrap/dropdown";
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import Cookies from "../../app/utils/cookies";
import { Currency } from "../../app/utils/currency";
import { SubSink } from "subsink";
import { createDetachedFrame } from "../../app/utils/functions.utils";
import _, { floor } from 'lodash';
import { Options } from '@angular-slider/ngx-slider';
import { TierService } from "../../app/services/tier.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import {
  Subject, timer
} from "rxjs";
import { debounce } from "rxjs/operators";
import { resolveInitialTypeFilter } from "./initial-type-filter";
import {
  applyOnlyPlayedDraft,
  createOnlyPlayedDraft,
  OnlyPlayedDraftState,
  resetOnlyPlayedDraft,
  syncOnlyPlayedDraftFromInput,
  toggleOnlyPlayedDraft,
} from "./only-played-draft";
import { Native } from "../../native";
import { toDisplayTime } from "../../app/utils/time-format-preference";
import { unixToRegTime, writtenFilterRegTime } from "../../app/utils/filter-reg-time";
import { IsFeatureEnable, SITE_COMBO_V2_ENABLED, SITE_COMBO_V2_FLAG_VALUE } from "../../app/utils/experiments";

@Component({
  selector: "filter-tournaments",
  templateUrl: "./filter-tournaments.component.html",
  styleUrls: ["./filter-tournaments.component.scss"],
  animations: [
    trigger(
      'inOutAnimation',
      [
        transition(
          ':enter',
          [
            style({ left: '-600px'}),
            animate('0.2s ease-out',
                    style({ left: '0'}))
          ]
        ),
        transition(
          ':leave',
          [
            style({ left: '0'}),
            animate('0.2s ease-in',
                    style({ left: '-600px'}))
          ]
        )
      ]
    ),
  ]
})
export class FilterTournamentsComponent implements OnInit {

  // Filters rendered on the main row, sharing the grid track left by the actions column.
  private static readonly MAIN_FILTER_KEYS = ['name', 'site', 'buy_in', 'prize_pool'];
  private static readonly MAIN_FILTER_XL_TRACK = 8;

  @Input() accentColor = 'light'
  @Input() totalTournaments = 0;
  @Input() showFilters = ['site', 'game', 'buy_in', 'speed', 'type', 'players', 'variant', 'state', 'prize_pool', 'init_stacks', 'date', 'time', 'end_time', 'name', 'order', 'onlyNew', 'scheduled', 'maxLate', 'field', 'duration', 'priority', 'onlyFast', 'favorite', 'currency', 'week_day']
  @Input() details;
  @Input() order;
  @Input() externalFavoritesState: boolean | null = null;
  @Input() mode = "tournaments"
  @Input() isAdmin = false;
  @Input() showHeader = false;
  @Input() useFloatingSitePicker = false;
  @Input() applyOnSearchOnly = false;
  @Input() showSavedFilters = true;
  private _isLoading = false;
  public uiIsLoading = false;
  @Input() set isLoading(value: boolean) {
    this._isLoading = !!value;
    Promise.resolve().then(() => {
      this.uiIsLoading = this._isLoading;
    });
  }
  get isLoading(): boolean {
    return this._isLoading;
  }
  @Input() dropdownListTiers = [];
  @Output() onlyPlayedChange = new EventEmitter<boolean>();
  private onlyPlayedState: OnlyPlayedDraftState = createOnlyPlayedDraft(false);

  @Input() set onlyPlayed(value: boolean) {
    this.onlyPlayedState = syncOnlyPlayedDraftFromInput(value);
  }
  get onlyPlayed(): boolean {
    return this.onlyPlayedState.applied;
  }
  get onlyPlayedDraft(): boolean {
    return this.onlyPlayedState.draft;
  }
  @Output() filterList = new EventEmitter<object>();
  @Output() clickedCollapse = new EventEmitter<boolean>();
  @Output() clickedAutoScheduler = new EventEmitter<void>();

  @ViewChild("filterDropdown") filterDropdown: BsDropdownDirective;
  @ViewChild("savedFilters") savedFilters: TemplateRef<any>;
  @ViewChild("autoSchedule") autoSchedule: TemplateRef<any>;
  @ViewChild("modalConfirmSave") modalConfirmSave: TemplateRef<any>;
  @ViewChild("modalConfirmSaveFilterSet") modalConfirmSaveFilterSet: TemplateRef<any>;

  filterSubject = new Subject<any>();


  sendFilterList(list: any, force: boolean = false) {
    if (this.applyOnSearchOnly && !force) {
      return;
    }

    if (this.shouldShowMultiFilterView && this.appliedFilters.length > 1) {
      const filtersArray = this.appliedFilters.map(filterId => {
        const filter = this.filters[filterId];
        return this.prepareFilterForSending(filter);
      });

      this.emitOnlyPlayedIfNeeded();
      this.filterList.emit({
        multiFilters: filtersArray,
        isMultiFilter: true
      });
    } else {
      var filtersToSend = this.prepareFilterForSending(list);
      this.emitOnlyPlayedIfNeeded();
      this.filterList.emit(filtersToSend);
    }
  }

  private prepareFilterForSending(list: any) {
    var filtersToSend = {...list}

    // \/ IGNORE TEMPORARILY REMOVED FILTERS
    filtersToSend.category = null;
    // /\ IGNORE TEMPORARILY REMOVED FILTERS

    // --------------------------------------------------------
    // || IF ANY CHANGE IS MADE HERE ABOUT THE FILTER DATA   ||
    // || MODEL AND/OR CONVERSION, TALK TO THE BACKEND TEAM  ||
    // --------------------------------------------------------

    //ADJUST FILTERS BEFORE SENDING

    // Helper: Convert time string (HH:MM) to Unix timestamp
    const timeToUnix = (timeStr: string): number | null => {
      if (!timeStr || timeStr === "") return null;
      const [hours, minutes] = timeStr.split(':');
      const date = new Date();
      date.setHours(Number(hours));
      date.setMinutes(Number(minutes));
      date.setSeconds(0, 0);
      return Math.floor(date.getTime() / 1000);
    };

    // Helper: Convert time string to ISO string
    const timeToISO = (timeStr: string): string | null => {
      if (!timeStr || timeStr === "") return null;
      const [hours, minutes] = timeStr.split(':');
      const date = new Date();
      date.setHours(Number(hours));
      date.setMinutes(Number(minutes));
      date.setSeconds(0, 0);
      return date.toISOString();
    };

    // Helper: Map array field or return null
    const mapArrayField = (arr: any[], field: 'item_id' | 'item_text' = 'item_id', defaultEmpty: any = null): any[] | null => {
      return arr?.length > 0 ? arr.map(e => e[field]) : defaultEmpty;
    };

    // Time conversions (Unix timestamps)
    filtersToSend.from_time = timeToUnix(list.from_time);
    filtersToSend.to_time = timeToUnix(list.to_time);
    filtersToSend.from_end_time = timeToUnix(list.from_end_time);
    filtersToSend.to_end_time = timeToUnix(list.to_end_time);

    // Registration time conversions (ISO strings)
    filtersToSend.from_register_time = timeToISO(list.from_register_time);
    filtersToSend.to_register_time = timeToISO(list.to_register_time);
    filtersToSend.from_datetime = timeToISO(list.from_datetime);
    filtersToSend.to_datetime = timeToISO(list.to_datetime);

    //FROM DATE
    if (list.from_date) {
      const original = new Date(list.from_date)
      filtersToSend.from_date = new Date(original.toISOString().slice(0, -1))
    }

    //TO DATE
    if (list.to_date) {
      const original = new Date(list.to_date)
      filtersToSend.to_date = new Date(original.toISOString().slice(0, -1))
    }

    // FROM DATETIME
    if (list.from_datetime && list.from_datetime != "") {
      const original = new Date()
      original.setHours(list.from_datetime.split(':')[0])
      original.setMinutes(list.from_datetime.split(':')[1])
      original.setSeconds(0, 0)
      filtersToSend.from_datetime = original.toISOString()
    }

    // TO DATETIME
    if (list.to_datetime && list.to_datetime != "") {
      const original = new Date()
      original.setHours(list.to_datetime.split(':')[0])
      original.setMinutes(list.to_datetime.split(':')[1])
      original.setSeconds(0, 0)
      filtersToSend.to_datetime = original.toISOString()
    }

    // FROM END REGISTER
    if (list.from_end_register && list.from_end_register != "") {
      const original = new Date()
      original.setHours(list.from_end_register.split(':')[0])
      original.setMinutes(list.from_end_register.split(':')[1])
      original.setSeconds(0, 0)
      filtersToSend.from_end_register = original.toISOString()
    } else {
      filtersToSend.from_end_register = null
    }

    // TO END REGISTER
    if (list.to_end_register && list.to_end_register != "") {
      const original = new Date()
      original.setHours(list.to_end_register.split(':')[0])
      original.setMinutes(list.to_end_register.split(':')[1])
      original.setSeconds(0, 0)
      filtersToSend.to_end_register = original.toISOString()
    } else {
      filtersToSend.to_end_register = null
    }

    //REMOVE FREEROLL IF SELECTED - FRONT ONLY FILTER -
    if (filtersToSend.type && filtersToSend.type.length > 0) {
      const typesWithoutFreeRoll = filtersToSend.type.filter(e => e.item_text != "Freeroll");
      filtersToSend.type = typesWithoutFreeRoll;
    }

    //ARRAYS - Performance optimization: batch array transformations
    filtersToSend.game2 = mapArrayField(filtersToSend.game2, 'item_id', undefined);
    filtersToSend.site = mapArrayField(filtersToSend.site, 'item_id', undefined);
    filtersToSend.players = mapArrayField(filtersToSend.players, 'item_text', undefined);
    filtersToSend.speed = mapArrayField(filtersToSend.speed, 'item_text', undefined);
    filtersToSend.state = mapArrayField(filtersToSend.state, 'item_text', undefined);
    filtersToSend.type = mapArrayField(filtersToSend.type, 'item_id', []);
    filtersToSend.variant = mapArrayField(filtersToSend.variant, 'item_text', undefined);
    filtersToSend.priority = mapArrayField(filtersToSend.priority, 'item_id', undefined);
    filtersToSend.category = mapArrayField(filtersToSend.category, 'item_id', undefined);
    filtersToSend.currency = mapArrayField(filtersToSend.currency, 'item_id', undefined);
    filtersToSend.week_day = mapArrayField(filtersToSend.week_day, 'item_id', undefined);

    // GAME
    if(filtersToSend.game2 == null) {
      filtersToSend.game2 = [1, 2, 3, 4, 5];
    }

    // BUY IN
    if (list.buy_in_min && filtersToSend.currency && filtersToSend.currency.length == 1) {
      filtersToSend.buy_in_min = Number(list.buy_in_min)
    }
    if (list.buy_in_max && filtersToSend.currency && filtersToSend.currency.length == 1) {
      filtersToSend.buy_in_max = Number(list.buy_in_max)
    }
    if(this.hasFreeRoll) {
      filtersToSend.buy_in_min = 0;
      filtersToSend.buy_in_max = 0;
    }

    // PRIZE POOL
    if (list.prize_pool_min && filtersToSend.currency && filtersToSend.currency.length == 1) {
      filtersToSend.prize_pool_min = Number(list.prize_pool_min)
    }

    if (list.prize_pool_max && filtersToSend.currency && filtersToSend.currency.length == 1) {
      filtersToSend.prize_pool_max = Number(list.prize_pool_max)
    }

    // REBALANCE
    if(window.location.pathname != "/rebalance") {
      filtersToSend.auto_only = null;
      filtersToSend.manual_only = null;
      filtersToSend.deleted_filter_only = null;
      filtersToSend.unchecked_filter_only = null;
    }

    // MANAGE FILTERS
    if(window.location.pathname == "/manage-filters") {
      filtersToSend.tier = this.tierSearch;
    }

    // GRIND STATES
    if(this.mode == 'grind') {
      filtersToSend.states = filtersToSend.state;
      filtersToSend.state = null;
    }

    //FORCE ABILITY MIN NULL WHEN NOT IN TOURNAMENTS MODE
    if(this.mode !== 'tournaments') {
      filtersToSend.av_ability_min = null;
    }

    // --------------------------------------------------------
    // || IF ANY CHANGE IS MADE HERE ABOUT THE FILTER DATA   ||
    // || MODEL AND/OR CONVERSION, TALK TO THE BACKEND TEAM  ||
    // --------------------------------------------------------

    return filtersToSend;
  }

  onClickAutoScheduler() {
    this.clickedAutoScheduler.emit();
  }

  @ViewChild('from_time') elementFromTime: ElementRef;
  @ViewChild('to_time') elementToTime: ElementRef;

  public openedSaved = false;
  public openedAuto = false;
  public loadingFilters = false;

  public showMultiFilterDetails: boolean = true;

  public hasFreeRoll = false;

  private subs = new SubSink();

  public isDarkTheme = Cookies.get('theme-ui') ? JSON.parse(Cookies.get('theme-ui')) : true;

  private readonly emptyFilter = {
    id: null,
    name: "New Filter",
    site: null,
    game2: null,
    buy_in_min: null,
    buy_in_max: null,
    speed: null,
    type: [],
    players: null,
    variant: null,
    state: null,
    prize_pool_min: null,
    prize_pool_max: null,
    init_stacks_min: null,
    init_stacks_max: null,
    from_date: null,
    to_date: null,
    from_time: null,
    to_time: null,
    search: "",
    order: window.location.pathname == "/rebalance" ? { start: 1 } : { state: 1 },
    onlyNew: false,
    scheduled: null,
    maxLate: false,
    field: null,
    from_duration: null,
    priority: null,
    to_duration: null,
    limit: null,
    include_closed: false,
    order_start: window.location.pathname == "/rebalance" ? 1 : 0,
    order_site: 0,
    order_game: 0,
    order_buy_in: 0,
    order_name: 0,
    order_prize_pool: 0,
    order_speed: 0,
    order_state: window.location.pathname == "/rebalance" ? 0 : 1,
    order_field: 0,
    order_duration: 0,
    order_register_time: 0,
    order_av_ability: 0,
    order_type: 0,
    onlyFast: false,
    from_register_time: null,
    to_register_time: null,
    timezone: new Date().getTimezoneOffset(),
    exclude: "",
    flagged_only: null,
    auto_scheduled_only: null,
    show_exception: false,
    category: null,
    av_ability_min: null,
    av_ability: null,
    favorites: null,
    currency: null,
    min_participants: null,
    week_day: null,
    from_end_time: null,
    to_end_time: null,
    order_grindstate: 0,
    order_priority: 0,
    auto_only: true,
    manual_only: false,
    deleted_filter_only: true,
    unchecked_filter_only: false,
    min_blind: null,
    max_blind: null,
    notifications: null
  };

  public rangeFilters = {
    participants: [2, 1000],
    duration: [0, 24],
    prize_pool: [2, 1000000],
    ability: [0, 50],
    blinds: [0, 1000]
  };

  public optionsParticipants: Options = {
    floor: 2,
    ceil: 1000,
    logScale: true,
    ticksArray: [2, 100, 500, 1000],
    getLegend: (value: number): string => {
      return value < 1000 ? value.toString() : '*';
    }
  }

  public optionsBlinds: Options = {
    floor: 1,
    ceil: 1000,
    logScale: true,
    ticksArray: [10, 25, 100, 500],
    getLegend: (value: number): string => {
      return value < 1000 ? value.toString() : '*';
    }
  }

  public optionsPrizePool: Options = {
    floor: 2,
    ceil: 1000000,
    logScale: true,
    ticksArray: [1, 100, 1000, 10000, 100000, 1000000],
    getLegend: (value: number): string => {
      return value < 1000000 ? value.toString() : '*';
    }
  }

  public currentUser: User = {
    id: null,
    team: "",
    role: "",
    schedules: [],
    profile: {
      sharkscope_nicks: [],
      grind_mode: {}
    },
  };

  public autoScheduleSelected: number = 0;
  public isEnableAutoSchedule: boolean = false;
  public isMassAutoSchedule: boolean = false;

  public isMaster = false;

  public saveFilterWarningText = "";

  public extraFiltersVisible = false;

  public selectedFilterIndex: number = 0;
  public appliedFilters: number[] = [0];
  public selectedFiltersForMultiApply: number[] = [];

  public checkedFilters: { [key: number]: boolean } = {};

  public downloadJsonHref: SafeUrl;

  public filters: { [key: number]: Filter } = { 0: { ..._.cloneDeep(this.emptyFilter), ...{ include_closed: window.location.pathname == "/rebalance" ? true : false} } };
  public filterIsAutoSchedule: { [key: number]: boolean } = { 0: false };
  public filterIsDeleted: { [key: number]: boolean } = { 0: false };
  public filterOwnerIsMaster: { [key: number]: boolean } = { 0: false };
  public filterMaster: { [key: number]: number } = {};
  public filterPriority: { [key: number]: number } = {};
  public filterRegTime: { [key: number]: string | null } = {};
  public filterRegTimeUnix: { [key: number]: number | null } = {};
  public filterUseRegTime: { [key: number]: boolean } = {};
  public filtersByMaster: { [key: number]: object } = {};
  public showFilterOptions = false;

  public currencyRates: { [key: string]: number } = {};
  public isoToSym = Currency.list

  public selectedCurrency = "$"

  // Snackbar Message
  public showSnackbar = false;
  public snackbarMessage = "";

  // Filters dropdown options
  public dropdownListSites = [];
  public dropdownListGame = [];
  public dropdownListGameAdmin = [];
  public dropdownListSpeed = [];
  public dropdownListType = [];
  public dropdownListPlayers = [];
  public dropdownListVariant = [];
  public dropdownListState = [];
  public dropdownListScheduled = [];
  public dropdownListAutoScheduled = [];
  public dropdownListAutoScheduledSearch = [];
  public dropdownListFlagged = [];
  public dropdownListPriority = [];
  public dropdownListCategory = [];
  public dropdownListCurrency = [];
  public dropdownListDay = [];
  public dropdownListMasters = [];
  public dropdownListStates = [];
  public dropdownListNotifications = [];

  public siteFavoriteIds: Array<number | string> = [];

  public bloquedFunctions = true;
  public today = new Date();

  public myTimeZone = moment.tz.guess();
  public filterFromDate: string;
  public filterToDate: string;
  public filterScheduled = [];
  public filterAutoScheduled = [];
  public filterNotifications = [];
  public filterFlagged = [];
  public filterName = "";

  private waitForNextKey: any;

  public currentPag = 1;

  private sites: Site[];
  private sitesMap: { [key: number]: Site } = {};

  public priority: string = "1";

  public siteComboV2Enabled$ = IsFeatureEnable(SITE_COMBO_V2_ENABLED, SITE_COMBO_V2_FLAG_VALUE);
  public dropdownSettings: IDropdownSettings = {};
  public dropdownSettingsSite: IDropdownSettings = {};
  public dropdownSettingsSingle: IDropdownSettings = {};
  public dropdownSettingsTeam: IDropdownSettings = {};

  public dateFromModel: IMyDateModel = null;
  public dateToModel: IMyDateModel = null;

  public searchModel = []
  public excludeModel = []

  public loadingAutoScheduler = false;
  public lockedAutoScheduler = false;

  // Import progress tracking
  public importProgress = {
    isImporting: false,
    current: 0,
    total: 0,
    currentStep: '',
    percentage: 0,
    failed: 0
  };

  // Export progress tracking
  public exportProgress = {
    isExporting: false,
    isReady: false
  };

  private exportTimeout: any = null;

  public filterSearch = "";
  public masterSearch = [];
  public tierSearch = [];
  public autoScheduleSearch = [{ item_id: true, item_text: this.translateService.instant("auto_scheduled") }, { item_id: false, item_text: this.translateService.instant("not_auto_scheduled") }];

  public dateFromOptions: IAngularMyDpOptions = {
    dateRange: false,
    dateFormat: this.translateService.currentLang == 'en-US' ? 'mm/dd/yyyy' : 'dd/mm/yyyy',
    disableSince: {year: 0, month: 0, day: 0},
    disableUntil: {year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() - 1}
  };

  public dateToOptions: IAngularMyDpOptions = {
    dateRange: false,
    dateFormat: this.translateService.currentLang == 'en-US' ? 'mm/dd/yyyy' : 'dd/mm/yyyy',
    disableUntil: {year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() - 1}
  };

  public datePastOptions: IAngularMyDpOptions = {
    dateRange: false,
    dateFormat: this.translateService.currentLang == 'en-US' ? 'mm/dd/yyyy' : 'dd/mm/yyyy'
  };

  constructor(
    private userService: UserService,
    private licenseService: LicenseService,
    private siteService: SiteService,
    private spinner: NgxSpinnerService,
    private location: Location,
    private translateService: TranslateService,
    private currencyService: CurrencyService,
    private sanitizer: DomSanitizer,
    private tierService: TierService,
    private modalService: BsModalService,
    private elem: ElementRef
  ) {}

  onDateChange(event: IMyDateModel, input: string): void {
    let newDate = event.singleDate.jsDate;
    if(newDate){
      const offset = newDate.getTimezoneOffset()
      newDate = new Date(newDate.getTime() - (offset*60*1000))
      input == 'from' ? this.filterFromDate = newDate.toISOString().split('T')[0] : this.filterToDate = newDate.toISOString().split('T')[0]
      let copy: IAngularMyDpOptions = this.getCopyOfOptions(input == 'from' ? 'to' : 'from');
      if(input == 'from'){
        copy.disableUntil = {year: newDate.getFullYear(),
          month: newDate.getMonth() + 1,
          day: newDate.getDate()};
        this.dateToOptions = copy;
      } else {
        copy.disableSince = {year: newDate.getFullYear(),
          month: newDate.getMonth() + 1,
          day: newDate.getDate()};
        this.dateFromOptions = copy;
      }
      this.onClickSubmitFilters()
    } else {
      input == 'from' ? this.filterFromDate = null : this.filterToDate = null
      this.resetDateFromUntil(input)
      this.onClickSubmitFilters()
    }
  }

  resetDateFromUntil(input: string){
    let copy: IAngularMyDpOptions = this.getCopyOfOptions(input == 'from' ? 'to' : 'from');
    if(input == 'from'){
      copy.disableUntil = {year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() - 1};
      this.dateToOptions = copy;
    } else {
      copy.disableSince = {year: 0, month: 0, day: 0};
      this.dateFromOptions = copy;
    }
  }

  getCopyOfOptions(input: string): IAngularMyDpOptions {
    return input == 'from' ? JSON.parse(JSON.stringify(this.dateFromOptions)) : JSON.parse(JSON.stringify(this.dateToOptions))
  }

  onClickSubmitFilters(order?: object, fromDeleteFilter?: boolean, searchAfter: boolean = true, withDebouncer: boolean = true) {

    if(this.searchModel){
      this.filters[this.selectedFilterIndex].search = this.searchModel.map((e) => {
        return e.label
      }).join('|')
    }

    if(this.excludeModel){
      this.filters[this.selectedFilterIndex].exclude = this.excludeModel.map((e) => {
        return e.label
      }).join('|')
    }

    if (this.filterFromDate) {
      this.filters[this.selectedFilterIndex].from_date = moment(
        this.filterFromDate
      ).format();
    } else {
      this.filters[this.selectedFilterIndex].from_date = null;
    }

    if (this.filterToDate) {
      this.filters[this.selectedFilterIndex].to_date = moment(
        this.filterToDate
      ).format();
    } else {
      this.filters[this.selectedFilterIndex].to_date = null;
    }

    if (this.filterScheduled[0]) {
      this.filters[this.selectedFilterIndex].scheduled = this.filterScheduled[0].item_id
    } else {
      this.filters[this.selectedFilterIndex].scheduled = null;
    }

    if (this.filterFlagged[0]) {
      this.filters[this.selectedFilterIndex].flagged_only = this.filterFlagged[0].item_id
    } else {
      this.filters[this.selectedFilterIndex].flagged_only = null;
    }

    if (this.filterAutoScheduled[0]) {
      this.filters[this.selectedFilterIndex].auto_scheduled_only = this.filterAutoScheduled[0].item_id
    } else {
      this.filters[this.selectedFilterIndex].auto_scheduled_only = null;
    }

    if (this.filterNotifications[0]) {
      this.filters[this.selectedFilterIndex].notifications = this.filterNotifications[0].item_id
    } else {
      this.filters[this.selectedFilterIndex].notifications = null;
    }

    if (this.filters[this.selectedFilterIndex].currency && this.filters[this.selectedFilterIndex].currency.length == 1) {
      this.selectedCurrency = this.filters[this.selectedFilterIndex].currency[0]["item_text"].split('-')[0]
    } else {
      this.selectedCurrency = "$";
    }

    const orderf = this.filters[this.selectedFilterIndex].order

    this.filters[this.selectedFilterIndex].order = orderf || {
      state: 1,
    };

    const prize_pool_max = this.filters[this.selectedFilterIndex].prize_pool_max
    const prize_pool_min = this.filters[this.selectedFilterIndex].prize_pool_min

    const buy_in_max = this.filters[this.selectedFilterIndex].buy_in_max
    const buy_in_min = this.filters[this.selectedFilterIndex].buy_in_min

    const field_min = this.filters[this.selectedFilterIndex].min_participants
    const field_max = this.filters[this.selectedFilterIndex].field

    const min_blind = this.filters[this.selectedFilterIndex].min_blind
    const max_blind = this.filters[this.selectedFilterIndex].max_blind

    buy_in_max ? parseInt(buy_in_max) < parseInt(buy_in_min) ? this.filters[this.selectedFilterIndex].buy_in_max = this.filters[this.selectedFilterIndex].buy_in_min : null : null

    if (this.filters[this.selectedFilterIndex].field != null && this.filters[this.selectedFilterIndex].field <= 0) {
      this.filters[this.selectedFilterIndex].field = Math.abs(this.filters[this.selectedFilterIndex].field)
    }

    if (this.filters[this.selectedFilterIndex].min_participants != null && this.filters[this.selectedFilterIndex].min_participants <= 0) {
      this.filters[this.selectedFilterIndex].min_participants = Math.abs(this.filters[this.selectedFilterIndex].min_participants)
    }

    field_max && field_min ? Number(field_max) < Number(field_min) ? this.filters[this.selectedFilterIndex].field = this.filters[this.selectedFilterIndex].min_participants : null : null

    if (this.filters[this.selectedFilterIndex].prize_pool_min != null && (Number(this.filters[this.selectedFilterIndex].prize_pool_min) <= 0)) {
      this.filters[this.selectedFilterIndex].prize_pool_min = Math.abs(this.filters[this.selectedFilterIndex].prize_pool_min)
    }

    if (this.filters[this.selectedFilterIndex].prize_pool_max != null && (Number(this.filters[this.selectedFilterIndex].prize_pool_max) <= 0)) {
      this.filters[this.selectedFilterIndex].prize_pool_max = Math.abs(this.filters[this.selectedFilterIndex].prize_pool_max)
    }

    prize_pool_max && prize_pool_min ? Number(prize_pool_max) < Number(prize_pool_min) ? this.filters[this.selectedFilterIndex].prize_pool_max = this.filters[this.selectedFilterIndex].prize_pool_min : null : null

    if (this.filters[this.selectedFilterIndex].min_blind != null && (Number(this.filters[this.selectedFilterIndex].min_blind) <= 0)) {
      this.filters[this.selectedFilterIndex].min_blind = Math.abs(this.filters[this.selectedFilterIndex].min_blind)
    }

    if (this.filters[this.selectedFilterIndex].max_blind != null && (Number(this.filters[this.selectedFilterIndex].max_blind) <= 0)) {
      this.filters[this.selectedFilterIndex].max_blind = Math.abs(this.filters[this.selectedFilterIndex].max_blind)
    }

    max_blind && min_blind ? Number(max_blind) < Number(min_blind) ? this.filters[this.selectedFilterIndex].max_blind = this.filters[this.selectedFilterIndex].min_blind : null : null

    if (this.bloquedFunctions) {
      this.filters[this.selectedFilterIndex].type = [{ item_id: 'freeroll', item_text: "Freeroll" }]
    }

    if (this.filters[this.selectedFilterIndex].to_end_time && this.filters[this.selectedFilterIndex].from_time) {
      this.filters[this.selectedFilterIndex].from_end_time = this.filters[this.selectedFilterIndex].from_time
    } else {
      this.filters[this.selectedFilterIndex].from_end_time = null;
    }

    this.hasFreeRoll = false;
    if (this.filters[this.selectedFilterIndex].type && this.filters[this.selectedFilterIndex].type.length > 0) {
      this.filters[this.selectedFilterIndex].type.map((e) => {
        if(e.item_text == "Freeroll") {
          this.filters[this.selectedFilterIndex].buy_in_min = "0";
          this.filters[this.selectedFilterIndex].buy_in_max = "0";
          this.hasFreeRoll = true;
        }
      })
    }
    if(!this.hasFreeRoll && Number(this.filters[this.selectedFilterIndex].buy_in_min) == 0 && Number(this.filters[this.selectedFilterIndex].buy_in_max) == 0) {
      this.filters[this.selectedFilterIndex].buy_in_min = null;
      this.filters[this.selectedFilterIndex].buy_in_max = null;
    } else if (this.hasFreeRoll) {
      this.filters[this.selectedFilterIndex].type = [{ item_id: 'freeroll', item_text: "Freeroll" }]
    }

    if(searchAfter && withDebouncer) {
      this.filterSubject.next(this.filters[this.selectedFilterIndex]);
    } else if(searchAfter && !withDebouncer) {
      this.sendFilterList(this.filters[this.selectedFilterIndex]);
    }
  }

  onKeyupSearch() {
    clearTimeout(this.waitForNextKey);
    this.waitForNextKey = setTimeout(() => {
      this.onClickSubmitFilters();
    }, 2000);
  }

  reset() {
    this.selectedFilterIndex = 0;
    this.appliedFilters = [0];
    this.selectedFiltersForMultiApply = [];
    this.filterName = "";
    this.filterFromDate = null;
    this.filterToDate = null;
    this.dateToModel = null;
    this.filterScheduled = [];
    this.filterAutoScheduled = [];
    this.filterNotifications = [];
    this.filterFlagged = [];
    this.dateFromModel = null;
    this.searchModel = [];
    this.excludeModel = [];
    this.resetDateFromUntil('from');
    this.resetDateFromUntil('to');
    if(this.extraFiltersVisible) {
      this.elementFromTime.nativeElement.value = '';
      this.elementToTime.nativeElement.value = '';
    }
    this.filters[0] = _.cloneDeep(this.emptyFilter);
    if(this.bloquedFunctions) {
      this.filters[0].type = [{ item_id: "freeroll", item_text: "Freeroll" }];
    } else if(this.mode === 'tournaments') {
      this.filters[0].type = [{ item_id: "Regular", item_text: "Regular" }];
    }
    this.filters[0].auto_scheduled_only = null;
    this.filters[0].include_closed = false;
    this.filters[0].auto_only = true;
    this.filters[0].manual_only = false;
    this.filters[0].deleted_filter_only = false;
    this.filters[0].unchecked_filter_only = false;
    this.filters[0].notifications = null;
    this.selectedCurrency = "$";
    this.onlyPlayedState = resetOnlyPlayedDraft();
    if (this.showFilters.includes('onlyPlayed')) {
      this.onlyPlayedChange.emit(false);
    }
    this.onClickSubmitFilters(null, false, true, false);
  }

  onClickSaveFilterSet() {
    this.toggleModal(this.modalConfirmSaveFilterSet);
  }

  async onClickConfirmSaveFilterSet() {
    try {
      this.spinner.show();

      const filtersToUpdate = [];

      for (const filterId of this.appliedFilters) {
        const filterData = { ...this.filters[filterId] };

        if (filterId === 0 || this.isFilterObjectEmpty(filterData)) {
          continue;
        }

        filterData.timezone = -new Date().getTimezoneOffset();

        filtersToUpdate.push({
          id: filterData.id,
          data: filterData,
          auto_schedule: this.filterIsAutoSchedule[filterData.id] || false,
          priority: Number(this.filterPriority[filterData.id]) || 1,
          ...this.echoedFilterRegTime(filterData.id)
        });
      }

      if (filtersToUpdate.length > 0) {
        if (filtersToUpdate.length > 100) {
          await this.processFiltersInChunks(filtersToUpdate, 100, 'Saving filter set');
        } else {
          await this.userService.updateUserFilter(filtersToUpdate).toPromise();
        }
      }

      await this.getFilters(this.selectedFilterIndex);
      this.showSnackMessage(this.translateService.instant('filter_set_saved_successfully'));

    } catch (error) {
      console.error('Error saving filter set:', error);
      this.showSnackMessage(this.translateService.instant('error_saving_filter_set'));
    } finally {
      this.spinner.hide();
    }
  }

  onClickClearAllFilters() {
    this.selectedFilterIndex = 0;
    this.appliedFilters = [0];
    this.selectedFiltersForMultiApply = [];

    this.reset();
  }

  private isFilterObjectEmpty(filter: any): boolean {
    if (!filter) return true;

    const hasContent = filter.site?.length > 0 ||
                      filter.game2?.length > 0 ||
                      filter.buy_in_min !== null ||
                      filter.buy_in_max !== null ||
                      filter.prize_pool_min !== null ||
                      filter.prize_pool_max !== null ||
                      filter.speed?.length > 0 ||
                      filter.type?.length > 0 ||
                      filter.players?.length > 0 ||
                      filter.variant?.length > 0 ||
                      filter.state?.length > 0 ||
                      filter.search ||
                      filter.from_date ||
                      filter.to_date;

    return !hasContent;
  }

  toggleMultiFilterVisibility() {
    this.showMultiFilterDetails = !this.showMultiFilterDetails;
  }

  async onClickSaveFilter(ignoreEmpty: boolean = false) {
    try {
      this.spinner.show();
      const index = this.selectedFilterIndex;
      const filterData = { ...this.filters[index] };

      if(!ignoreEmpty && (filterData.site == null || (filterData.site && filterData.site.length == 0))) {
        this.toggleModal(this.modalConfirmSave);
        this.saveFilterWarningText = this.translateService.instant("confirm_save_filter_text");
      } else if (!ignoreEmpty && (filterData.buy_in_min == null && filterData.buy_in_max == null)) {
        this.toggleModal(this.modalConfirmSave);
        this.saveFilterWarningText = this.translateService.instant("confirm_save_filter_text_buy_in");
      } else {
        const isNewFilter = filterData.id === 0 || filterData.id === null;

        if (isNewFilter || filterData.name != this.filterName) {
          await this.getFilters(this.selectedFilterIndex);
          const duplicateFilter = Object.entries(this.filters).find(([key, filter]) => {
            return Number(key) !== 0 &&
                   Number(key) !== filterData.id &&
                   filter.name &&
                   filter.name.trim().toLowerCase() === this.filterName.trim().toLowerCase() &&
                   !this.filterIsDeleted[Number(key)];
          });

          if (duplicateFilter) {
            filterData.id = Number(duplicateFilter[0]);
          } else if (filterData.name != this.filterName) {
            filterData.id = 0;
          }
        }

        filterData.name = this.filterName;
        filterData.timezone = -new Date().getTimezoneOffset();
        const data = await this.userService.updateUserFilter([{
          id: filterData.id,
          data: filterData,
          auto_schedule: this.filterIsAutoSchedule[filterData.id],
          priority: Number(this.filterPriority[filterData.id]),
          ...this.echoedFilterRegTime(filterData.id)
        }]).toPromise();

        const savedFilterId = data.ids[0];
        filterData.id = savedFilterId;

        this.selectedFilterIndex = savedFilterId;

        this.getFilters(savedFilterId);
        this.showSnackMessage(this.translateService.instant('filter_updated'));
      }
    } finally {
      this.spinner.hide();
    }
  }

  async getCurrentUser(i: number) {
    this.currentUser = await this.userService.getCurrentUser().toPromise();
    const role = await this.userService.getRole().toPromise()
    this.isMaster = role.master;
    const license = await this.licenseService
    .getLicense()
    .then((e) => e.license.toLowerCase());
    this.bloquedFunctions = !role.ta && !role.sa && (!license || license === "");
  }

  async openSavedFilters() {
    this.openedSaved = true;
    this.loadingFilters = true;
    this.toggleModal(this.savedFilters, 'modal-xl');

    await this.getFilters(this.selectedFilterIndex);

    if (this.mode === 'tournaments' || this.mode === 'grind') {
      this.selectedFiltersForMultiApply = [...this.appliedFilters.filter(id => id !== 0)];
    }

    this.loadingFilters = false;
  }

  async openAutoSchedule() {
    this.loadingFilters = true;
    this.toggleModal(this.autoSchedule, 'modal-xl');
    await this.getFilters(this.selectedFilterIndex);
    this.openedAuto = true;
    this.loadingFilters = false;
   }

  async getFilters(resetIndex: number = 0) {
    var filterList = [];
    this.showFilterOptions = false;
    if(this.isMaster) {
      filterList = await this.userService.getFiltersFromTier(true).toPromise();
    } else {
      filterList = await this.userService.getFilters().toPromise();
    }
    if(!this.filters.hasOwnProperty('0')) {
      this.filters = { 0: { ..._.cloneDeep(this.emptyFilter), ...{ include_closed: window.location.pathname == "/rebalance" ? true : false} } };
    }
    filterList.forEach(filter => {
      if (filter.data && filter.data.hasOwnProperty('only_favorites')) {
        filter.data.favorites = filter.data.only_favorites;
        delete filter.data.only_favorites;
      }
      const data = filter.data;
      data.id = filter.id;
      if (filter.user_id == null) {
        filter.user_id = this.currentUser.id
      }
      if (filter.is_master == null || filter.user_id == this.currentUser.id) {
        this.filterOwnerIsMaster[filter.id] = true;
      } else {
        this.filterOwnerIsMaster[filter.id] = filter.is_master;
        if(filter.is_master) {
          this.showFilterOptions = true;
        }
      }
      this.filterPriority[filter.id] = filter.priority;
      this.filterRegTime[filter.id] = unixToRegTime(filter.reg_time);
      this.filterRegTimeUnix[filter.id] = filter.reg_time ?? null;
      this.filterUseRegTime[filter.id] = !!filter.use_reg_time;
      this.filters[filter.id] = data;
      this.filterIsAutoSchedule[filter.id] = filter.auto_schedule;
      this.filterIsDeleted[filter.id] = filter.deleted;
      this.checkedFilters[filter.id] = false;
      this.filterMaster[filter.id] = filter.user_id;
      if(this.filtersByMaster[filter.user_id]) {
        this.filtersByMaster[filter.user_id]["filters"].push(filter.id)
      } else if (filter.is_master) {
        this.filtersByMaster[filter.user_id] = {name: filter.user_name, filters: [filter.id]}
        this.dropdownListMasters.push({ item_id: filter.user_id, item_text: filter.user_name })
        if(Number(filter.user_id) == Number(this.currentUser.id)) {
          this.masterSearch = [{ item_id: filter.user_id, item_text: filter.user_name }]
        }
      }
    })
    this.selectedFilterIndex = resetIndex;
  }

  showFilterFromMaster(id: number) {
    if (!this.isMaster) {
      return true;
    }
    var found = false;
    this.masterSearch.map((e) => {
      const filters = this.filtersByMaster[e.item_id]['filters'];
      if(filters.includes(Number(id))) {
        this.autoScheduleSearch.map((x) => {
          if(x.item_id == this.filterIsAutoSchedule[id]) {
            found = true;
          }
        })
      }
    })
    return found;
  }

  checkFilter(id, check){
    this.checkedFilters[id] = check;
  }

  isAllFiltersChecked() {
    for (const [key, value] of Object.entries(this.filters)) {
      if((this.filterSearch == '' || ((value.name).toUpperCase()).includes(this.filterSearch.toUpperCase())) && !this.filterIsDeleted[key] && !this.checkedFilters[key]) {
        return false;
      }
    }
    return true;
  }

  checkAllFilters(check) {
    for (const [key, value] of Object.entries(this.filters)) {
      if ((this.filterSearch == '' || ((value.name).toUpperCase()).includes(this.filterSearch.toUpperCase())) && !this.filterIsDeleted[key] && value.id > 0) {
        this.checkedFilters[key] = check;
      } else {
        this.checkedFilters[key] = false;
      }
    }
  }

  isFilterCheckedEmpty() {
    for (const [key, value] of Object.entries(this.filters)) {
      if((this.filterSearch == '' || ((value.name).toUpperCase()).includes(this.filterSearch.toUpperCase())) && this.checkedFilters[key]){
        return false;
      }
    }
    return true;
  }

  handleExportClick() {
    if (this.exportProgress.isExporting) {
      return;
    }

    this.prepareFiltersJson();
  }

  prepareFiltersJson() {
    if (this.exportTimeout) {
      clearTimeout(this.exportTimeout);
      this.exportTimeout = null;
    }

    this.exportProgress.isExporting = true;
    this.exportProgress.isReady = false;
    
    this.exportTimeout = setTimeout(async () => {
      this.exportTimeout = null;

      try {
        var array = []
        var failedFilters = [];

        for (const [key, value] of Object.entries(this.filters)) {
          const isMultiFilterMode = this.mode === 'tournaments' || this.mode === 'grind';

          const isSelected = isMultiFilterMode
            ? this.selectedFiltersForMultiApply.includes(+key)
            : this.checkedFilters[key];

          if(value.id > 0 && isSelected && this.filterOwnerIsMaster[key] && this.filterMaster[key] == this.currentUser.id && !this.filterIsDeleted[key] && (this.filterSearch == '' || ((value.name).toUpperCase()).includes(this.filterSearch.toUpperCase()))) {
            try {
              if (!value.name || value.name.trim() === '') {
                failedFilters.push('Unnamed filter');
                continue;
              }

              JSON.stringify(value);
              array.push(value);
            } catch (error) {
              console.error('Filter serialization failed:', error);
              failedFilters.push(value.name || 'Unknown filter');
            }
          }
        }

        if(array.length == 0) {
          this.exportProgress.isReady = false;

          if (failedFilters.length > 0) {
            this.showSnackMessage(this.translateService.instant('no_filters_exported_failed', { filters: failedFilters.join(', ') }));
          } else {
            this.showSnackMessage(this.translateService.instant('no_filters_selected_for_export'));
          }
        } else {
          var theJSON = JSON.stringify(array, null, 2);

          JSON.parse(theJSON);
          
          await this.triggerDownload(theJSON, 'filters.json');
          this.exportProgress.isReady = true;

          if (failedFilters.length > 0) {
            this.showSnackMessage(this.translateService.instant('filters_download_initiated_with_failures', { count: array.length, failedFilters: failedFilters.join(', ') }));
          } else {
            this.showSnackMessage(this.translateService.instant('filters_download_initiated', { count: array.length }));
          }
        }
      } catch (error) {
        console.error('JSON creation failed:', error);
        this.exportProgress.isReady = false;
        this.showSnackMessage(this.translateService.instant('export_failed_invalid_data'));
      } finally {
        this.exportProgress.isExporting = false;
      }
    }, 300);
  }

  private async triggerDownload(content: string, filename: string) {
    if (Native.IsNative()) {
      const saved = await Native.saveTextToUserPath(content, filename, [
        { name: 'JSON', extensions: ['json'] },
      ]);

      if (saved) {
        return;
      }
    }

    const blob = new Blob([content], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  async importFiltersJson(target: HTMLInputElement) {
    var selectedFile = target.files[0];

    if (!selectedFile) {
      return;
    }

    const fileReader: any = new FileReader();
    await fileReader.readAsText(selectedFile, "UTF-8");

    fileReader.onload = async () => {
      try {
        var result = JSON.parse(fileReader.result);

        this.importProgress.isImporting = true;
        this.importProgress.total = result.length;
        this.importProgress.current = 0;
        this.importProgress.percentage = 0;
        this.importProgress.currentStep = '';
        this.importProgress.failed = 0;

        const validFilters = result.filter(filter => filter && filter.id != null);
        this.importProgress.total = validFilters.length;

        if (validFilters.length === 0) {
          this.showSnackMessage(this.translateService.instant('no_valid_filters_found'));
          this.importProgress.isImporting = false;
          return;
        }

        const filtersToImport = [];

        for (let i = 0; i < validFilters.length; i++) {
          const filter = validFilters[i];

          this.importProgress.current = i + 1;
          this.importProgress.percentage = Math.round((this.importProgress.current / this.importProgress.total) * 30);
          this.importProgress.currentStep = this.translateService.instant('preparing_filters');

          filter.id = 0;

          for (const [key, value] of Object.entries(this.filters)) {
            if(filter.name == value.name && !this.filterIsDeleted[key]){
              filter.name = this.translateService.instant("copy_of") + " " + filter.name;
            }
          }

          filtersToImport.push({
            id: 0,
            data: filter,
            auto_schedule: false,
            priority: 0,
            reg_time: null,
            use_reg_time: false
          });

          await new Promise(resolve => setTimeout(resolve, 20));
        }

        try {
          this.importProgress.percentage = 35;
          this.importProgress.currentStep = this.translateService.instant('importing_batch_of_filters', { current: filtersToImport.length, total: this.importProgress.total });

          if (filtersToImport.length > 0) {
            if (filtersToImport.length > 100) {
              await this.processFiltersInChunksWithProgress(filtersToImport, 100, 'Importing filters');
            } else {
              this.importProgress.percentage = 70;
              await this.userService.updateUserFilter(filtersToImport).toPromise();
            }
          }

          this.importProgress.current = this.importProgress.total;
          this.importProgress.percentage = 100;
          this.importProgress.currentStep = this.translateService.instant('complete');

        } catch (error) {
          console.error('Error importing filters:', error);
          this.importProgress.failed = filtersToImport.length;
          this.importProgress.currentStep = this.translateService.instant('invalid_file_format');
        }

        await this.getFilters();

        this.importProgress.percentage = 100;
        this.importProgress.currentStep = this.translateService.instant('complete');

        const successCount = validFilters.length - this.importProgress.failed;
        if (this.importProgress.failed > 0) {
          this.showSnackMessage(this.translateService.instant('import_success_with_failures', { successCount, failedCount: this.importProgress.failed }));
        } else {
          this.showSnackMessage(this.translateService.instant('import_success', { successCount }));
        }
      } catch (error) {
        console.error('Error parsing import file:', error);
        this.showSnackMessage(this.translateService.instant('invalid_file_format'));
      } finally {
        this.importProgress.isImporting = false;
        this.importProgress.current = 0;
        this.importProgress.total = 0;
        this.importProgress.percentage = 0;
        this.importProgress.currentStep = '';
        this.importProgress.failed = 0;
      }
    }

    fileReader.onerror = (error) => {
      console.error('Error reading file:', error);
      this.showSnackMessage(this.translateService.instant('error_reading_file'));
      this.importProgress.isImporting = false;
    }
  }

  get availableFilters() {
    return Object.keys(this.filters).length > 1;
  }

  asIsOrder(a: KeyValue<number, any>, b: KeyValue<number, any>) {
    return a.value.name.toLowerCase() > b.value.name.toLowerCase() ? 1 : a.value.name.toLowerCase() === b.value.name.toLowerCase() ? 0 : -1;
  }

  asIsOrderFilters(a: KeyValue<string, any>, b: KeyValue<string, any>) {
    var orderedFilters = [
      "search", "site", "buy_in_min", "buy_in_max", "min_blind", "max_blind", "from_time", "to_time", "prize_pool_min", "prize_pool_max", "speed", "exclude", "variant", "min_participants", "field", "players", "av_ability_min", "av_ability", "from_date", "to_date", "week_day", "from_end_time", "to_end_time", "maxLate", "include_closed", "scheduled", "currency", "priority", "favorites", "show_exception", "from_register_time", "to_register_time", "state", "auto_scheduled_only", "notifications", "flagged_only", "category", "from_duration", "type", "game", "id", "init_stacks_max", "init_stacks_min", "limit", "name", "onlyFast", "onlyNew", "order", "order_av_ability", "order_buy_in", "order_duration", "order_field", "order_game", "order_grindstate", "order_name", "order_prize_pool", "order_priority", "order_register_time", "order_site", "order_speed", "order_start", "order_state", "timezone", "to_duration", "type"
    ];

    return orderedFilters.indexOf(a.key) > orderedFilters.indexOf(b.key) ? 1 : -1;
  }

  get shouldShowMultiFilterView(): boolean {
    return (this.mode === 'tournaments' || this.mode === 'grind') && this.appliedFilters.length > 1;
  }

  toggleFilterSelection(filterId: number, isSelected: boolean) {
    if (isSelected) {
      if (!this.selectedFiltersForMultiApply.includes(filterId)) {
        this.selectedFiltersForMultiApply.push(filterId);
      }
    } else {
      this.selectedFiltersForMultiApply = this.selectedFiltersForMultiApply.filter(id => id !== filterId);
    }

  }

  onClickSavedFilterAndClose(filterId: number): void {
    this.onClickSavedFilter(filterId);
    this.toggleModal();
  }

  applySelectedFilters() {
    if (this.mode !== 'tournaments' && this.mode !== 'grind') {
      if (this.selectedFiltersForMultiApply.length > 0) {
        this.onClickSavedFilter(this.selectedFiltersForMultiApply[0]);
      }
    } else {
      if (this.selectedFiltersForMultiApply.length > 0) {
        this.appliedFilters = [];

        this.selectedFiltersForMultiApply.forEach(filterId => {
          if (filterId !== 0) {
            this.addFilterToApplied(filterId);
          }
        });

        if (this.appliedFilters.length === 0) {
          this.appliedFilters = [0];
        } else {
          this.setEditingFilter(this.appliedFilters[0]);

          this.onClickSubmitFilters();
        }
      } else {
        this.appliedFilters = [0];
      }
    }

    this.selectedFiltersForMultiApply = [];
    this.toggleModal();
  }

  addFilterToApplied(filterId: number) {
    if (!this.appliedFilters.includes(filterId)) {
      this.appliedFilters.push(filterId);
    }
  }

  removeFilterFromApplied(filterId: number) {
    const wasInMultiFilterMode = this.shouldShowMultiFilterView;

    this.appliedFilters = this.appliedFilters.filter(id => id !== filterId);

    if (filterId === this.selectedFilterIndex) {
      if (this.appliedFilters.length === 0) {
        this.appliedFilters = [0];
        this.selectedFilterIndex = 0;
      } else {
        this.selectedFilterIndex = this.appliedFilters[0];
      }

      this.updateUIForSelectedFilter(this.selectedFilterIndex);
    }

    if (this.appliedFilters.length === 0) {
      this.appliedFilters = [0];
      this.selectedFilterIndex = 0;
    }

    if (this.shouldShowMultiFilterView || wasInMultiFilterMode) {
      this.sendFilterList(this.filters[this.selectedFilterIndex]);
    }
  }

  setEditingFilter(filterId: number) {
    this.selectedFilterIndex = filterId;
    this.updateUIForSelectedFilter(filterId);
  }

  private updateUIForSelectedFilter(filterId: number) {
    const filter = this.filters[filterId];
    if (!filter) return;

    this.filterName = filter.name || '';

    const search = (filter.search || '').trim();
    if (search.length === 0) {
      this.searchModel = []
    } else {
      this.searchModel = search.split('|').filter(e => e.length > 0).map(e => ({ label: e }))
    }

    const exclude = (filter.exclude || '').trim();
    if (exclude.length === 0) {
      this.excludeModel = []
    } else {
      this.excludeModel = exclude.split('|').filter(e => e.length > 0).map(e => ({ label: e }))
    }

    if (filter.currency && filter.currency.length == 1) {
      this.selectedCurrency = filter.currency[0]["item_text"].split('-')[0]
    } else {
      this.selectedCurrency = "$";
    }

    if (filter.scheduled !== undefined && filter.scheduled !== null) {
      const scheduledText = filter.scheduled ? this.translateService.instant("scheduled") : this.translateService.instant("not_scheduled")
      this.filterScheduled = [{ item_id: filter.scheduled, item_text: scheduledText }]
    } else {
      this.filterScheduled = [];
    }

    if (filter.auto_scheduled_only !== undefined && filter.auto_scheduled_only !== null) {
      const autoScheduledText = filter.auto_scheduled_only ? this.translateService.instant("auto_scheduled") : this.translateService.instant("manually_scheduled")
      this.filterAutoScheduled = [{ item_id: filter.auto_scheduled_only, item_text: autoScheduledText }]
    } else {
      this.filterAutoScheduled = [];
    }

    if (filter.notifications !== undefined && filter.notifications !== null) {
      const notificationsText = filter.notifications ? this.translateService.instant("with_notifications") : this.translateService.instant("without_notifications")
      this.filterNotifications = [{ item_id: filter.notifications, item_text: notificationsText }]
    } else {
      this.filterNotifications = [];
    }

    if (filter.flagged_only !== undefined && filter.flagged_only !== null) {
      const flaggedText = filter.flagged_only ? this.translateService.instant("flagged") : this.translateService.instant("not_flagged")
      this.filterFlagged = [{ item_id: filter.flagged_only, item_text: flaggedText }]
    } else {
      this.filterFlagged = [];
    }
  }

  getAppliedFilters() {
    if (this.mode !== 'tournaments' && this.mode !== 'grind') {
      return [{
        id: this.selectedFilterIndex,
        filter: this.filters[this.selectedFilterIndex],
        isEditing: true
      }];
    }

    return this.appliedFilters.map(id => ({
      id,
      filter: this.filters[id],
      isEditing: id === this.selectedFilterIndex
    }));
  }

  trackByFilterId(index: number, item: any): number {
    return item.id;
  }

  areAllVisibleFiltersSelected(): boolean {
    if (this.mode !== 'tournaments' && this.mode !== 'grind') {
      return this.isAllFiltersChecked();
    }

    const visibleFilters = Object.keys(this.filters)
      .map(key => parseInt(key))
      .filter(filterId => {
        const filter = this.filters[filterId];
        return filterId !== 0 &&
              this.filterOwnerIsMaster[filterId] &&
              this.filterMaster[filterId] == this.currentUser.id &&
              !this.filterIsDeleted[filterId] &&
              (!this.filterSearch || filter.name.toLowerCase().includes(this.filterSearch.toLowerCase()));
      });

    return visibleFilters.length > 0 &&
          visibleFilters.every(filterId => this.selectedFiltersForMultiApply.includes(filterId));
  }

  selectAllVisibleFilters(selectAll: boolean) {
    if (this.mode !== 'tournaments' && this.mode !== 'grind') {
      this.checkAllFilters(selectAll);
      return;
    }

    if (selectAll) {
      const visibleFilters = Object.keys(this.filters)
        .map(key => parseInt(key))
        .filter(filterId => {
          const filter = this.filters[filterId];
          return filterId !== 0 &&
                this.filterOwnerIsMaster[filterId] &&
                this.filterMaster[filterId] == this.currentUser.id &&
                !this.filterIsDeleted[filterId] &&
                (!this.filterSearch || filter.name.toLowerCase().includes(this.filterSearch.toLowerCase()));
        });

      visibleFilters.forEach(filterId => {
        if (!this.selectedFiltersForMultiApply.includes(filterId)) {
          this.selectedFiltersForMultiApply.push(filterId);
        }
      });
    } else {
      const visibleFilters = Object.keys(this.filters)
        .map(key => parseInt(key))
        .filter(filterId => {
          const filter = this.filters[filterId];
          return filterId !== 0 &&
                this.filterOwnerIsMaster[filterId] &&
                this.filterMaster[filterId] == this.currentUser.id &&
                !this.filterIsDeleted[filterId] &&
                (!this.filterSearch || filter.name.toLowerCase().includes(this.filterSearch.toLowerCase()));
        });

      this.selectedFiltersForMultiApply = this.selectedFiltersForMultiApply.filter(
        filterId => !visibleFilters.includes(filterId)
      );
    }

  }

  async onClickSavedFilter(i: number) {
    this.selectedFilterIndex = i;
    this.filterName = this.filters[i]?.name || '';

    const search = (this.filters[i]?.search || '').trim();
    if(search.length === 0) {
      this.searchModel = []
    } else {
      this.searchModel = search.split('|').filter(e => e.length > 0).map(e => ({ label: e }))
    }

    const exclude = (this.filters[i]?.exclude || '').trim();
    if (exclude.length === 0) {
      this.excludeModel = []
    } else {
      this.excludeModel = exclude.split('|').filter(e => e.length > 0).map(e => ({ label: e }))
    }

    if (this.filters[i].currency && this.filters[i].currency.length == 1) {
      this.selectedCurrency = this.filters[i].currency[0]["item_text"].split('-')[0]
    } else {
      this.selectedCurrency = "$";
    }

    if (this.filters[i]?.scheduled != undefined && this.filters[i]?.scheduled != null) {
      const scheduledText = this.filters[i]?.scheduled ? this.translateService.instant("scheduled") : this.translateService.instant("not_scheduled")
      this.filterScheduled = [{ item_id: this.filters[i]?.scheduled, item_text: scheduledText }]
    } else {
      this.filterScheduled = [];
    }

    if (this.filters[i]?.auto_scheduled_only != undefined && this.filters[i]?.auto_scheduled_only != null) {
      const autoScheduledText = this.filters[i]?.auto_scheduled_only ? this.translateService.instant("auto_scheduled") : this.translateService.instant("manually_scheduled")
      this.filterAutoScheduled = [{ item_id: this.filters[i]?.auto_scheduled_only, item_text: autoScheduledText }]
    } else {
      this.filterAutoScheduled = [];
    }

    if (this.filters[i]?.notifications != undefined && this.filters[i]?.notifications != null) {
      const notificationsText = this.filters[i]?.notifications ? this.translateService.instant("with_notifications") : this.translateService.instant("without_notifications")
      this.filterNotifications = [{ item_id: this.filters[i]?.notifications, item_text: notificationsText }]
    } else {
      this.filterNotifications = [];
    }

    if(this.filters[i]?.flagged_only != undefined && this.filters[i]?.flagged_only != null) {
      const flaggedText = this.filters[i]?.flagged_only ? this.translateService.instant("flagged") : this.translateService.instant("not_flagged")
      this.filterFlagged = [{ item_id: this.filters[i]?.flagged_only, item_text: flaggedText }]
    } else {
      this.filterFlagged = [];
    }

    const today = new Date();

    if(this.filters[i]?.from_date) {
      const fromDate = new Date(this.filters[i].from_date)
      if(today < fromDate) {
        this.filters[i].from_date = null;
      }
    }

    if(this.filters[i]?.to_date) {
      const toDate = new Date(this.filters[i].to_date)
      if(today > toDate) {
        this.filters[i].to_date = null;
      }
    }

    this.onClickSubmitFilters(null, false, true, false);
  }

  toggleFavoritesFilter() {
    const currentValue = this.filters[this.selectedFilterIndex].favorites;

    if (currentValue === null || currentValue === undefined) {
      this.filters[this.selectedFilterIndex].favorites = true;
    } else if (currentValue === true) {
      this.filters[this.selectedFilterIndex].favorites = false;
    } else {
      this.filters[this.selectedFilterIndex].favorites = null;
    }

    this.sendFilterList(this.filters[this.selectedFilterIndex]);
  }

  toggleOnlyPlayedFilter() {
    this.onlyPlayedState = toggleOnlyPlayedDraft(this.onlyPlayedState);
  }

  private emitOnlyPlayedIfNeeded() {
    if (!this.showFilters.includes('onlyPlayed')) {
      return;
    }

    this.onlyPlayedState = applyOnlyPlayedDraft(this.onlyPlayedState);
    this.onlyPlayedChange.emit(this.onlyPlayedState.applied);
  }

  isAllAutoSchedule() {
    var isTrue = true;
    for (const [key, value] of Object.entries(this.filterIsAutoSchedule)) {
      const data = this.filters[key];

      if((this.filterSearch == '' || ((data.name).toUpperCase()).includes(this.filterSearch.toUpperCase())) && Number(key) != 0 && !this.filterIsDeleted[key] && this.filterMaster[key] == this.currentUser.id && !value) {
        isTrue = false;
      }
    }
    return isTrue;
  }

  async onClickOpenAutoSchedule(id: number, enable: boolean, isMass: boolean = false) {

    if(isMass) {
      this.isMassAutoSchedule = true;
      this.isEnableAutoSchedule = enable;
    } else {
      this.isEnableAutoSchedule = enable;
      this.autoScheduleSelected = id;
      this.isMassAutoSchedule = false;
    }

  }

  async onClickChangeAutoSchedule() {
    try {
      this.spinner.show();

      if(this.isMassAutoSchedule) {
        const filtersToUpdate = [];

        for (const [key, value] of Object.entries(this.filterIsAutoSchedule)) {
          if(Number(key) != 0 && this.filterMaster[key] == this.currentUser.id && !this.filterIsDeleted[key]) {

            const data = this.filters[key];

            if((this.filterSearch == '' || ((data.name).toUpperCase()).includes(this.filterSearch.toUpperCase()))) {
              this.filterIsAutoSchedule[key] = this.isEnableAutoSchedule;

              data.timezone = -new Date().getTimezoneOffset();

              filtersToUpdate.push({
                id: data.id,
                data,
                auto_schedule: this.isEnableAutoSchedule,
                priority: Number(this.filterPriority[data.id]),
                ...this.echoedFilterRegTime(data.id)
              });
            }
          }
        }

        if (filtersToUpdate.length > 0) {
          if (filtersToUpdate.length > 100) {
            await this.processFiltersInChunks(filtersToUpdate, 100, 'Updating auto-schedule');
          } else {
            await this.userService.updateUserFilter(filtersToUpdate).toPromise();
          }
        }

      } else {

        this.filterIsAutoSchedule[this.autoScheduleSelected] = this.isEnableAutoSchedule;

        const data = this.filters[this.autoScheduleSelected];

        data.timezone = -new Date().getTimezoneOffset();

        await this.userService.updateUserFilter([{
          id: data.id,
          data,
          auto_schedule: this.isEnableAutoSchedule,
          priority: Number(this.filterPriority[data.id]),
          ...this.echoedFilterRegTime(data.id)
        }]).toPromise();

      }
    } finally {
      localStorage.setItem("refresh-schedules", "true");
      this.openAutoSchedule();
      this.spinner.hide();
    }
  }

  getPriorityText(priority) {
    const value = Number(priority);
    switch (value) {
      case 0:
        return "N/A";
      case 1:
        return "1 - " + this.translateService.instant('VERY_LOW');
      case 2:
      return "2 - " + this.translateService.instant('VERY_LOW');
      case 3:
      return "3 - " + this.translateService.instant('LOW');
      case 4:
      return "4 - " + this.translateService.instant('LOW');
      case 5:
      return "5 - " + this.translateService.instant('MEDIUM');
      case 6:
      return "6 - " + this.translateService.instant('MEDIUM');
      case 7:
      return "7 - " + this.translateService.instant('MEDIUM');
      case 8:
      return "8 - " + this.translateService.instant('HIGH');
      case 9:
      return "9 - " + this.translateService.instant('HIGH');
      case 10:
      return "10 - " + this.translateService.instant('HIGH');
    }
  }

  async processFiltersInChunks(filters: any[], chunkSize: number = 100, operationName: string = 'Processing') {
    const totalChunks = Math.ceil(filters.length / chunkSize);

    for (let i = 0; i < totalChunks; i++) {
      const startIdx = i * chunkSize;
      const endIdx = Math.min(startIdx + chunkSize, filters.length);
      const chunk = filters.slice(startIdx, endIdx);

      if (totalChunks > 1) {
        console.log(`${operationName} chunk ${i + 1}/${totalChunks} (${chunk.length} filters)`);
      }

      try {
        await this.userService.updateUserFilter(chunk).toPromise();
      } catch (error) {
        console.error(`Error in chunk ${i + 1}:`, error);
        throw error;
      }

      if (i < totalChunks - 1) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }
  }

  async processFiltersInChunksWithProgress(filters: any[], chunkSize: number = 100, operationName: string = 'Processing') {
    const totalChunks = Math.ceil(filters.length / chunkSize);

    for (let i = 0; i < totalChunks; i++) {
      const startIdx = i * chunkSize;
      const endIdx = Math.min(startIdx + chunkSize, filters.length);
      const chunk = filters.slice(startIdx, endIdx);

      const chunkProgress = 35 + Math.round(((i + 1) / totalChunks) * 60);
      this.importProgress.percentage = chunkProgress;
      this.importProgress.currentStep = this.translateService.instant('importing');

      try {
        await this.userService.updateUserFilter(chunk).toPromise();
      } catch (error) {
        console.error(`Error in chunk ${i + 1}:`, error);
        throw error;
      }

      if (i < totalChunks - 1) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }
  }

  async onClickChangePriority(id) {
    try {
      this.spinner.show();

      const data = this.filters[id];

      data.timezone = -new Date().getTimezoneOffset();

      await this.userService.updateUserFilter([{
        id: data.id,
        data,
        auto_schedule: this.filterIsAutoSchedule[data.id],
        priority: Number(this.filterPriority[data.id]),
        ...this.echoedFilterRegTime(data.id)
      }]).toPromise();

    } finally {
      this.spinner.hide();
    }
  }

  private echoedFilterRegTime(id: number): { reg_time: number | null; use_reg_time: boolean } {
    return {
      reg_time: this.filterRegTimeUnix[id] ?? null,
      use_reg_time: !!this.filterUseRegTime[id],
    };
  }

  async onChangeRegTime(id) {
    const written = writtenFilterRegTime(this.filterRegTime[id]);
    if (written.reg_time === (this.filterRegTimeUnix[id] ?? null)) {
      return;
    }

    try {
      this.spinner.show();

      this.filterRegTimeUnix[id] = written.reg_time;
      this.filterUseRegTime[id] = written.use_reg_time;

      const data = this.filters[id];

      data.timezone = -new Date().getTimezoneOffset();

      await this.userService.updateUserFilter([{
        id: data.id,
        data,
        auto_schedule: this.filterIsAutoSchedule[data.id],
        priority: Number(this.filterPriority[data.id]),
        ...written
      }]).toPromise();

    } finally {
      this.spinner.hide();
    }
  }

  showSnackMessage(msg: string) {
    this.snackbarMessage = msg;
    this.showSnackbar = true;
    setTimeout(() => {
      this.showSnackbar = false;
    }, 3000);
  }

  async onClickConfirmDeleteFilter() {
    try {
      this.spinner.show();

      let filtersToDelete = [];

      if (this.mode === 'tournaments' || this.mode === 'grind') {
        for (const filterId of this.selectedFiltersForMultiApply) {
          if (filterId !== 0 && this.filterMaster[filterId] === this.currentUser.id) {
            filtersToDelete.push(filterId);

            if (this.appliedFilters.includes(filterId)) {
              this.removeFilterFromApplied(filterId);
            }
          }
        }
        this.selectedFiltersForMultiApply = [];
      } else {
        for (const [key, value] of Object.entries(this.filters)) {
          if ((this.filterSearch === '' || ((value.name).toUpperCase()).includes(this.filterSearch.toUpperCase())) &&
              this.checkedFilters[key] &&
              Number(key) !== 0 &&
              this.filterMaster[key] === this.currentUser.id) {
            filtersToDelete.push(Number(key));
            this.onClickSubmitFilters(undefined, true);
          }
        }
      }

      if (filtersToDelete.length > 0) {
        await this.userService.deleteUserFilter(filtersToDelete).toPromise();
      }

      await this.getFilters();
      this.showSnackMessage(this.translateService.instant('filters_deleted_successfully'));
    } catch (e) {
      console.error('Error deleting filters:', e);
      this.showSnackMessage(this.translateService.instant('error_deleting_filters'));
    } finally {
      this.spinner.hide();
    }
  }

  async getSites() {
    this.subs.sink = this.siteService.getSitesHelpers(this.isAdmin).subscribe((data) => {
      this.sites = Array.isArray(data?.sites) ? data.sites : [];
      this.sitesMap = data?.sitesMap || {};
      let ddSites = this.sites.map((element) => {
        return { item_id: element.id, item_text: element.name, region: element.region };
      });
      this.dropdownListSites = ddSites;
      this.siteFavoriteIds = this.sites.filter((site) => site.favorite).map((site) => site.id);
    });
  }

  onSitePickerSelectedChange(selected: any[] | null): void {
    this.filters[this.selectedFilterIndex].site = selected;
  }

  applySitePicker(): void {
    this.onClickSubmitFilters(undefined, null, true, false);
  }

  get mainFilterColumnClass(): string {
    const visibleCount = FilterTournamentsComponent.MAIN_FILTER_KEYS
      .filter((key) => this.showFilters.includes(key)).length;

    if (visibleCount === 0) {
      return '';
    }

    const lgSpan = visibleCount === 1 ? 12 : visibleCount === 3 ? 4 : 6;
    const xlTrack = FilterTournamentsComponent.MAIN_FILTER_XL_TRACK;

    // Equal-width columns when the available track can't be split into integer spans.
    if (xlTrack % visibleCount !== 0) {
      return `col-lg-${lgSpan} col-xl`;
    }

    const xlSpan = xlTrack / visibleCount;
    return `col-lg-${lgSpan} col-xl-${xlSpan} col-xxl-${xlSpan}`;
  }

  get isSitePickerDisabled(): boolean {
    if (this.selectedFilterIndex === 0) {
      return false;
    }

    const selectedFilterId = this.filters[this.selectedFilterIndex]?.id;
    const ownerId = selectedFilterId != null ? this.filterMaster[selectedFilterId] : null;

    // While filter ownership is loading, keep the control enabled to avoid dead UI.
    if (ownerId == null || this.currentUser?.id == null) {
      return false;
    }

    return ownerId !== this.currentUser.id;
  }

  async getCurrencies(){
    const data = await this.currencyService.getCurrencies().toPromise()
    this.currencyRates = data.rates;
  }

  toggleCollapse(): void {
    this.extraFiltersVisible = !this.extraFiltersVisible;
    this.clickedCollapse.emit(true)
  }

  openExternal(event: MouseEvent, url: string) {
    event.preventDefault();
    Native.openExternal(url);
  }

  public getCurrentLang(){
    return this.translateService.currentLang
  }

  isFilterEmpty() {
    return _.isEqual(this.filters[this.selectedFilterIndex], this.emptyFilter)
  }

  isThereBadge() {
    const selectedFilter = this.filters?.[this.selectedFilterIndex];
    if (!selectedFilter) {
      return false;
    }

    return Object.keys(selectedFilter).some((key) => {
      const value = selectedFilter[key];
      return !!this.getFilterBadgeText({ key, value });
    });
  }

  anyFilterArrayOption(filter: string, removeFreeRoll: boolean = false) {
    if(removeFreeRoll) {
      if (this.filters[this.selectedFilterIndex].type && this.filters[this.selectedFilterIndex].type.length > 0) {
        const typesWithoutFreeRoll = this.filters[this.selectedFilterIndex].type.filter(e => e.item_text != "Freeroll");
        this.filters[this.selectedFilterIndex].type = typesWithoutFreeRoll;
      }
    }
    if(this.filterMaster[this.filters[this.selectedFilterIndex]['id']] == this.currentUser.id || this.selectedFilterIndex == 0) {
      this.filters[this.selectedFilterIndex][filter] = null;
      this.onClickSubmitFilters();
    }
  }

  toggleFilterArrayOption(filter:string, option:any) {
    if(this.filterMaster[this.filters[this.selectedFilterIndex]['id']] == this.currentUser.id || this.selectedFilterIndex == 0) {
      if(this.filters[this.selectedFilterIndex][filter]) {
        const i = this.filters[this.selectedFilterIndex][filter].findIndex(e => e.item_id === option.item_id);
        if(i > -1){
          this.filters[this.selectedFilterIndex][filter].splice(i, 1);
        } else {
          this.filters[this.selectedFilterIndex][filter].push(option)
        }
      } else {
        this.filters[this.selectedFilterIndex][filter] = [option];
      }
      if(this.filters[this.selectedFilterIndex][filter] && this.filters[this.selectedFilterIndex][filter].length == 0) {
        this.filters[this.selectedFilterIndex][filter] = null;
      }
      this.onClickSubmitFilters();
    }
  }

  filterArrayHasOption(filter:string, option:any):boolean {
    if(this.filters[this.selectedFilterIndex][filter]) {
      return this.filters[this.selectedFilterIndex][filter].some(e => e.item_id === option.item_id)
    } else {
      return false;
    }
  }

  changedRangeFilter(filter, newValue = null, isInput = false) {
    if(isInput) {
      this.rangeFilters[filter] = newValue;
    } else {
      if(filter == 'participants') {
        this.filters[this.selectedFilterIndex].min_participants = this.rangeFilters.participants[0];
        this.filters[this.selectedFilterIndex].field = this.rangeFilters.participants[1] < 1000 ? this.rangeFilters.participants[1] : null;
      }
      if(filter == 'prize_pool') {
        this.filters[this.selectedFilterIndex].prize_pool_min = this.rangeFilters.prize_pool[0];
        this.filters[this.selectedFilterIndex].prize_pool_max = this.rangeFilters.prize_pool[1] < 1000000 ? this.rangeFilters.prize_pool[1] : null;
      }
      if(filter == 'duration') {
        this.filters[this.selectedFilterIndex].from_duration = this.rangeFilters.duration[0];
        this.filters[this.selectedFilterIndex].to_duration = this.rangeFilters.duration[1];
      }
      if(filter == 'ability') {
        this.filters[this.selectedFilterIndex].av_ability_min = this.rangeFilters.ability[0];
        this.filters[this.selectedFilterIndex].av_ability = this.rangeFilters.ability[1];
      }
      if(filter == 'blinds') {
        this.filters[this.selectedFilterIndex].min_blind = this.rangeFilters.blinds[0];
        this.filters[this.selectedFilterIndex].max_blind = this.rangeFilters.blinds[1] < 1000 ? this.rangeFilters.blinds[1] : null;
      }
    }
    this.onKeyupSearch();
  }

  getFilterBadgeText(filter: any) {
    var filtersToIgnore = ['order', 'timezone', 'order_type', 'order_state', 'name', 'onlyNew', 'order_av_ability', 'order_buy_in', 'order_duration', 'order_field', 'order_game', 'order_grindstate', 'order_name', 'order_prize_pool', 'order_priority', 'order_register_time', 'order_site', 'order_speed', 'order_start', 'from_duration', 'to_duration', 'limit', 'id', 'from_end_time'];

    //Ignore min ability when not in tournaments mode
    if(this.mode !== 'tournaments') {
      filtersToIgnore.push('av_ability_min');
    }

    if(window.location.pathname != "/rebalance") {
      filtersToIgnore.push('auto_only', 'manual_only', 'deleted_filter_only', 'unchecked_filter_only');
    }

    var filtersBoolean = ['maxLate', 'show_exception', 'onlyFast', 'show_disabled', 'include_past']
    var timeFilters = ['from_end_time', 'from_register_time', 'from_time', 'to_end_time', 'to_register_time', 'to_time']

    var i18n = {
      week_day: "day_of_the_week",
      av_ability: "max_ability",
      av_ability_min: "min_ability",
      site: "site",
      game: "game",
      game2: "game",
      buy_in_min: "buy_in_min",
      buy_in_max: "buy_in_max",
      speed: "speed",
      type: "type",
      players: "players",
      variant: "variant",
      state: "state",
      prize_pool_min: "prize_pool_min",
      prize_pool_max: "prize_pool_max",
      init_stacks_min: "init_stacks_min",
      init_stacks_max: "init_stacks_max",
      from_date: "start",
      to_date: "to_date",
      from_time: "from_time",
      to_time: "to_time",
      from_datetime: "from_time",
      to_datetime: "to_time",
      search: "search_by_name",
      scheduled: "scheduled",
      maxLate: "only_max_late_tournaments",
      field: "max_participants",
      priority: "priority",
      include_closed: "include_closed",
      onlyFast: "only_fast",
      from_register_time: "from_registration_time",
      to_register_time: "to",
      from_end_register: "from_end_register",
      to_end_register: "to_end_register",
      exclude: "exclude",
      flagged_only: "flagged_only",
      auto_scheduled_only: "auto_scheduled",
      show_exception: "show_exception",
      category: "category",
      favorites: "favorite_schedules",
      currency: "currency",
      min_participants: "min_participants",
      from_end_time: "end_time",
      to_end_time: "end_time",
      show_disabled: "only_disabled_tournaments",
      include_past: "include_past_tournaments",
      auto_only: "auto_scheduled",
      manual_only: "manually_scheduled",
      deleted_filter_only: "deleted_filter",
      unchecked_filter_only: "filter_unchecked",
      min_blind: "blinds_min",
      max_blind: "blinds_max",
      notifications: "notifications"
    }

    if(filtersToIgnore.includes(filter.key) || (filter.value === this.emptyFilter[filter.key] && (filter.key != 'auto_only' && filter.key != 'manual_only' && filter.key != 'deleted_filter_only' && filter.key != 'unchecked_filter_only')) || filter.value === "" || filter.value === null) {
      return null;
    }

    const key = filter.key;

    if(filter.value.constructor === Array) {
      if (filter.value.length > 0) {
        const values = filter.value.map((val) => {
          return val.item_text ?? val
        })
        return this.translateService.instant(i18n[key]) + ": " + values.join(', ');
      } else {
        return null;
      }
    } else if (key == 'auto_only' || key == 'manual_only' || key == 'deleted_filter_only' || key == 'unchecked_filter_only') {
      if(filter.value.toString() == 'true') {
        return this.translateService.instant(i18n[key]) + ": " + this.translateService.instant('filter_' + filter.value.toString());
      } else {
        return null;
      }
    } else if (key == 'search' || key == 'exclude') {
      const values = filter.value.split('|');
      return this.translateService.instant(i18n[key]) + ": " + values.join(', ');
    } else if (key == 'favorites') {
      if (filter.value === true) {
        return this.translateService.instant("only_favorite_tournaments");
      } else if (filter.value === false) {
        return this.translateService.instant("exclude_favorites");
      } else {
        return null;
      }
    } else if (timeFilters.includes(key)) {
      return this.translateService.instant(i18n[key]) + ": " + toDisplayTime(String(filter.value));
    } else if (filtersBoolean.includes(key)) {
      return this.translateService.instant(i18n[key]);
    } else if (key == 'from_date' || key == 'to_date') {
      return this.translateService.instant(i18n[key]) + ": " + filter.value.split('T')[0];
    } else if (filter.value.toString() == 'true' || filter.value.toString() == 'false') {
      return this.translateService.instant(i18n[key]) + ": " + this.translateService.instant('filter_' + filter.value.toString());
    } else if (i18n[key]) {
      return this.translateService.instant(i18n[key]) + ": " + filter.value;
    } else {
      return key.toString() + ": " + filter.value;
    }
  }

  allRebalanceFiltersChecked() {
    var all = true;
    if(this.filters[this.selectedFilterIndex].auto_only != true) {
      all = false;
    }
    if(this.filters[this.selectedFilterIndex].manual_only != true) {
      all = false;
    }
    if(this.filters[this.selectedFilterIndex].deleted_filter_only != true) {
      all = false;
    }
    if(this.filters[this.selectedFilterIndex].unchecked_filter_only != true) {
      all = false;
    }
    return all;
  }

  checkAllRebalanceFilters() {
    this.filters[this.selectedFilterIndex].auto_only = true;
    this.filters[this.selectedFilterIndex].manual_only = true;
    this.filters[this.selectedFilterIndex].deleted_filter_only = true;
    this.filters[this.selectedFilterIndex].unchecked_filter_only = true;
    this.onClickSubmitFilters();
  }

  removeFilterBadge(filter: any) {
    if(filter.key == "buy_in_min" || filter.key == "buy_in_max") {
      this.hasFreeRoll = false;
      if (this.filters[this.selectedFilterIndex].type && this.filters[this.selectedFilterIndex].type.length > 0) {
        const typesWithoutFreeRoll = this.filters[this.selectedFilterIndex].type.filter(e => e.item_text != "Freeroll");
        this.filters[this.selectedFilterIndex].type = typesWithoutFreeRoll;
      }
    }
    if(filter.key == "to_end_time" || filter.key == "from_time") {
      this.filters[this.selectedFilterIndex].from_end_time = null;
    }
    if(filter.key == "auto_only" || filter.key == "manual_only" || filter.key == "deleted_filter_only" || filter.key == "unchecked_filter_only") {
      this.filters[this.selectedFilterIndex][filter.key] = null;
    } else if (filter.key == "include_closed") {
      this.filters[this.selectedFilterIndex][filter.key] = false;
    } else {
      this.filters[this.selectedFilterIndex][filter.key] = _.cloneDeep(this.emptyFilter[filter.key]);
    }
    if(this.bloquedFunctions) {
      this.filters[this.selectedFilterIndex].type = [{ item_id: "freeroll", item_text: "Freeroll" }];
      this.filters[this.selectedFilterIndex].buy_in_min = "0";
      this.filters[this.selectedFilterIndex].buy_in_max = "0";
      this.hasFreeRoll = true;
    }
    this.sendFilterList(this.filters[this.selectedFilterIndex])
  }

  goToOnTimeTournaments(): void {
    createDetachedFrame("/on-time-tournaments");
  }

  goToGrindMode(): void {
    createDetachedFrame("/grind-mode");
  }

  async onClickExecuteAutoScheduler() {
    this.loadingAutoScheduler = true;
    try {
      await this.tierService.executeAutoScheduler().toPromise();
      this.onClickAutoScheduler();
    } catch (e) {
      this.showSnackMessage(e);
    } finally {
      this.showSnackMessage(this.translateService.instant("auto_schedule_success"));
      this.loadingAutoScheduler = false;
      this.lockedAutoScheduler = true;
      setTimeout(() => {
        this.lockedAutoScheduler = false;
      }, 60000);
    }
  }

  onClickSubmit():void {
    if (this.applyOnSearchOnly) {
      this.sendFilterList(this.filters[this.selectedFilterIndex], true);
      return;
    }

    this.filterSubject.next({skipDebounce: true, ...this.filters[this.selectedFilterIndex]});
  }

  async ngOnInit() {
      await this.getCurrentUser(0);

      this.getCurrencies();

      this.modalService.onHide.subscribe(() => {
        this.openedSaved = false;
        this.openedAuto = false;
      });

      let routeState = this.location.getState();
      if (
        routeState["buyin"] != undefined &&
        routeState["speed"] != undefined &&
        routeState["horario"] != undefined
      ) {
        this.filters[this.selectedFilterIndex].buy_in_max = routeState["buyin"];
        this.filters[this.selectedFilterIndex].buy_in_min = routeState["buyin"];
        this.filters[this.selectedFilterIndex].speed = routeState["speed"];
        this.filters[this.selectedFilterIndex].from_time =
          routeState["horario"];
        this.filters[this.selectedFilterIndex].to_time = routeState["horario"];
      }

      this.getSites();

      this.dropdownListGame = [
        { item_id: 1, item_text: "NLH" },
        { item_id: 2, item_text: "PLO4" },
        { item_id: 4, item_text: "PLO5" },
        { item_id: 5, item_text: "PLO6" },
      ];

      this.dropdownListGameAdmin = [
        { item_id: 1, item_text: "NLH" },
        { item_id: 2, item_text: "PLO4" },
        { item_id: 3, item_text: "Other" },
        { item_id: 4, item_text: "PLO5" },
        { item_id: 5, item_text: "PLO6" },
      ];

      this.dropdownListPlayers = [
        { item_id: "Full Ring", item_text: "7 to 10 (Full Ring)" },
        { item_id: "6-Max", item_text: "6-Max" },
        { item_id: "3 to 5-Max", item_text: "3 to 5-Max" },
        { item_id: "2 (Heads Up)", item_text: "2 (Heads-Up)" },
      ];
      this.dropdownListSpeed = [
        { item_id: "Hyper-Turbo", item_text: "Hyper-Turbo" },
        { item_id: "Turbo", item_text: "Turbo" },
        { item_id: "Regular", item_text: "Regular" },
        { item_id: "Slow", item_text: "Slow" },
      ];
      this.dropdownListType = [
        { item_id: "Regular", item_text: "Regular" },
        { item_id: "Satellite", item_text: "Satellite" },
        { item_id: "Flight", item_text: "Flight" }
      ];

      this.dropdownListVariant = [
        { item_id: "Regular", item_text: "Regular" },
        { item_id: "Knockout", item_text: "Knockout" },
        { item_id: "Mystery", item_text: "Mystery" }
      ];

      this.dropdownListState = [
        { item_id: "Late Registration", item_text: "Late Registration" },
        { item_id: "Announced", item_text: "Announced" },
      ];

      this.dropdownListStates = [
        { item_id: "Late Registration", item_text: "Late Registration" },
        { item_id: "Announced", item_text: "Announced" },
        { item_id: "Closed", item_text: "Closed" },
      ];

      this.dropdownListScheduled = [
        { item_id: true, item_text: this.translateService.instant("scheduled") },
        { item_id: false, item_text: this.translateService.instant("not_scheduled") },
      ]

      this.dropdownListFlagged = [
        { item_id: true, item_text: this.translateService.instant("flagged") },
        { item_id: false, item_text: this.translateService.instant("not_flagged") },
      ]

      this.dropdownListAutoScheduled = [
        { item_id: true, item_text: this.translateService.instant("auto_scheduled") },
        { item_id: false, item_text: this.translateService.instant("manually_scheduled") },
      ]

      this.dropdownListAutoScheduledSearch = [
        { item_id: true, item_text: this.translateService.instant("auto_scheduled") },
        { item_id: false, item_text: this.translateService.instant("not_auto_scheduled") },
      ]

      this.dropdownListNotifications = [
        { item_id: true, item_text: this.translateService.instant("with_notifications") },
        { item_id: false, item_text: this.translateService.instant("without_notifications") },
      ]

      this.dropdownListPriority = [
        { item_id: 0, item_text: "N/A" },
        { item_id: 1, item_text: "1 - VERY LOW" },
        { item_id: 2, item_text: "2 - VERY LOW" },
        { item_id: 3, item_text: "3 - LOW" },
        { item_id: 4, item_text: "4 - LOW" },
        { item_id: 5, item_text: "5 - MEDIUM" },
        { item_id: 6, item_text: "6 - MEDIUM" },
        { item_id: 7, item_text: "7 - MEDIUM" },
        { item_id: 8, item_text: "8 - HIGH" },
        { item_id: 9, item_text: "9 - HIGH" },
        { item_id: 10, item_text: "10 - HIGH" },
      ];

      this.dropdownListCategory = [
        { item_id: 0, item_text: "Standard" },
        { item_id: 1, item_text: "Series" },
      ];

      this.dropdownListCurrency = Currency.list.map(e => {
        return {
          item_id: e.iso,
          item_text: `${e.symbol} - ${e.iso}`
        }
      })

      this.dropdownListDay = [
        { item_id: 0, item_text: this.translateService.instant("sunday") },
        { item_id: 1, item_text: this.translateService.instant("monday") },
        { item_id: 2, item_text: this.translateService.instant("tuesday") },
        { item_id: 3, item_text: this.translateService.instant("wednesday") },
        { item_id: 4, item_text: this.translateService.instant("thursday") },
        { item_id: 5, item_text: this.translateService.instant("friday") },
        { item_id: 6, item_text: this.translateService.instant("saturday") }
      ];

      this.dropdownSettings = {
        singleSelection: false,
        idField: "item_id",
        textField: "item_text",
        selectAllText: "Select All",
        unSelectAllText: "UnSelect All",
        disabledField: "item_disabled",
        itemsShowLimit: 2,
        allowSearchFilter: false,
        enableCheckAll: true,
      };

      this.dropdownSettingsSite = {
        singleSelection: false,
        idField: "item_id",
        textField: "item_text",
        selectAllText: "Select All",
        unSelectAllText: "UnSelect All",
        disabledField: "item_disabled",
        itemsShowLimit: 1,
        allowSearchFilter: false,
        enableCheckAll: true,
      };

      this.dropdownSettingsTeam = {
        singleSelection: false,
        idField: "email",
        textField: "fullname",
        selectAllText: "Select All",
        unSelectAllText: "UnSelect All",
        itemsShowLimit: 1,
        allowSearchFilter: false,
        enableCheckAll: false,
      };

      this.dropdownSettingsSingle = {
        singleSelection: true,
        idField: "item_id",
        textField: "item_text",
        selectAllText: "Select All",
        unSelectAllText: "UnSelect All",
        itemsShowLimit: 2,
        allowSearchFilter: false,
        enableCheckAll: false,
      };

      const initialType = resolveInitialTypeFilter(this.mode, this.bloquedFunctions);
      this.filters[this.selectedFilterIndex]['type'] = initialType.type;
      if (initialType.hasFreeRoll) {
        this.hasFreeRoll = true;
      }
      if (initialType.zeroBuyIn) {
        this.filters[this.selectedFilterIndex]['buy_in_min'] = "0";
        this.filters[this.selectedFilterIndex]['buy_in_max'] = "0";
      }

      this.filterSubject.pipe(debounce((filters) => timer(filters.skipDebounce ? 0 : 300))).subscribe((filters: any) => {
        this.sendFilterList(filters);
      });

      if (this.bloquedFunctions && this.mode === 'stats') {
        this.sendFilterList(this.filters[this.selectedFilterIndex], true);
      }
  }

  ngOnChanges(changes: SimpleChanges) {
    const selectedFilter = this.filters[this.selectedFilterIndex];
    if (!selectedFilter) {
      return;
    }

    selectedFilter.order_start = this.order?.start ?? selectedFilter.order_start ?? 0;
    selectedFilter.order_site = this.order?.site ?? selectedFilter.order_site ?? 0;
    selectedFilter.order_game = this.order?.game ?? selectedFilter.order_game ?? 0;
    selectedFilter.order_buy_in = this.order?.buy_in ?? selectedFilter.order_buy_in ?? 0;
    selectedFilter.order_name = this.order?.name ?? selectedFilter.order_name ?? 0;
    selectedFilter.order_prize_pool = this.order?.prize_pool ?? selectedFilter.order_prize_pool ?? 0;
    selectedFilter.order_speed = this.order?.speed ?? selectedFilter.order_speed ?? 0;
    selectedFilter.order_state = this.order?.state ?? selectedFilter.order_state ?? 0;
    selectedFilter.order_grindstate = this.order?.state ?? selectedFilter.order_grindstate ?? 0;
    selectedFilter.order_field = this.order?.field ?? selectedFilter.order_field ?? 0;
    selectedFilter.order_duration = this.order?.duration ?? selectedFilter.order_duration ?? 0;
    selectedFilter.order_priority = this.order?.priority ?? selectedFilter.order_priority ?? 0;
    selectedFilter.order_register_time = this.order?.register_time ?? selectedFilter.order_register_time ?? 0;
    selectedFilter.order_av_ability = this.order?.av_ability ?? selectedFilter.order_av_ability ?? 0;
    selectedFilter.order_type = this.order?.type ?? selectedFilter.order_type ?? 0;

    if (changes.externalFavoritesState) {
      const normalizedFavoritesState = this.externalFavoritesState === true || this.externalFavoritesState === false
        ? this.externalFavoritesState
        : null;
      this.filters[this.selectedFilterIndex].favorites = normalizedFavoritesState;
    }

  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();

    if (this.exportTimeout) {
      clearTimeout(this.exportTimeout);
      this.exportTimeout = null;
    }
  }

  private sharedModal: BsModalRef;
  toggleModal(template?: TemplateRef<any>, size: string = 'modal-md') {
    if (template) {
      this.sharedModal = this.modalService.show(template, { class: size });
    } else if (this.sharedModal != null) {
      if (this.importProgress.isImporting) {
        this.showSnackMessage(this.translateService.instant('wait_import_complete_before_closing'));
        return;
      }
      this.sharedModal.hide();
    }
  }

}
